import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { StatutStats } from '../../../service/coursera-dashboard-stats.model';
import { Chart, ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-coursera-statut-chart',
  templateUrl: './coursera-statut-chart.component.html',
  styleUrls: ['./coursera-statut-chart.component.css'],
})
export class CourseraStatutChartComponent implements OnChanges {
  @Input() data: StatutStats[] = [];
  @ViewChild('statutChart') chartRef!: ElementRef;

  chart!: Chart;

  ngOnChanges(): void {
    // 🔥 si pas de données → laisser le template afficher noData
    if (!this.data || this.data.length === 0) return;

    // 🔥 attendre que le canvas soit rendu par *ngIf
    setTimeout(() => {
      this.createChart();
    });
  }

  createChart() {
    if (!this.chartRef?.nativeElement) return;

    const ctx = this.chartRef.nativeElement.getContext('2d');

    const labels = this.data.map((d) => d.statut);
    const values = this.data.map((d) => d.total);

    // 🔥 destroy ancien chart si existe
    if (this.chart) {
      this.chart.destroy();
    }

    const config: ChartConfiguration = {
      type: 'pie',
      data: {
        labels,
        datasets: [
          {
            data: values,
          },
        ],
      },
      options: {
        responsive: true,
      },
    };

    this.chart = new Chart(ctx, config);
  }
}
